import React, { useState, useEffect, useRef } from 'react';
import { Grid, InputBase, Typography, List, ListItem, Paper } from '@material-ui/core';
import { searchForTable } from '../../components/apiHelper';
import useStyles from 'src/app/maintenance/assets/styles';

export const TableNameSearch = ({ value, onChange, error, disabled, onSelect }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const [options, setOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const wrapperRef = useRef(null);
  const debounceTimeout = useRef(null);
  const classes = useStyles();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (value) {
      setInputValue(value.includes('(') ? value : `${value}`);
    } else {
      setInputValue('');
    }
  }, [value]);

  useEffect(() => {
    if (inputValue.trim().length > 0) {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        fetchTableOptions(inputValue);
      }, 1000); // 1 second debounce
    } else {
      setOptions([]);
      setIsOpen(false);
    }

    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [inputValue]);

  const fetchTableOptions = async (searchTerm) => {
    try {
      setIsSearching(true);
      const response = await searchForTable(searchTerm);
      setOptions(response.data || []);
      setIsOpen(response.data && response.data.length > 0);
    } catch (error) {
      console.error('Error fetching tables:', error);
      setOptions([]);
      setIsOpen(false);
    } finally {
      setIsSearching(false);
    }
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    if (!e.target.value) {
      onChange({ target: { name: 'tableName', value: '' } });
    }
  };

  const handleSelectOption = (option) => {
    const displayValue = option.label 
      ? `${option.label} (${option.name})`
      : option.name;
      
    setInputValue(displayValue);
    onChange({ target: { name: 'tableName', value: option.name } });
    if (onSelect) {
      onSelect(option.name); 
    }
    setIsOpen(false);
  };

  return (
    <Grid container ref={wrapperRef} style={{ position: 'relative' }}>
      <InputBase
        className={classes.formInput}
        type="text"
        placeholder="Search table by label or name"
        name="tableName"
        value={inputValue}
        onChange={handleInputChange}
        disabled={disabled}
        onFocus={() => inputValue && options.length > 0 && setIsOpen(true)}
      />
      
      {isOpen && options.length > 0 && (
        <Paper className={classes.dropdown}>
          <List>
            {options.map((option) => (
              <ListItem 
                button 
                key={option.sys_id}
                onClick={() => handleSelectOption(option)}
                className={classes.option}
              >
                {`${option.label} (${option.name})`}
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
      
      {error && (
        <Grid
          item
          container
          xs={12}
          md={12}
          justifyContent="flex-end"
          alignItems="center"
          style={{ padding: "0px 8px" }}
        >
          <Typography className={classes.errorText}>
            {error}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};